import { useMapGetter } from 'dashboard/composables/store';
import {
  canAccessSidebarItem,
  canAccessConversationSubsection,
} from 'dashboard/constants/sidebarPermissions';

export function useSidebarPermissions() {
  const role = useMapGetter('getCurrentRole');
  return {
    canAccessItem: name => canAccessSidebarItem(name, role.value),
    canAccessConversationSubsection: name =>
      canAccessConversationSubsection(name, role.value),
  };
}
